(function ($) {
    $(function () {
        // Make .basic-article behave as a big link if it contains a heading
        // link in a way that preserves the accessibility of a simple text-based
        // heading link.
        $('.basic-article').each(function (articleIndex, articleNode) {
            var article = $(articleNode);
            var link = article.find('.basic-article__heading-link');

            if (link.length === 0) {
                return;
            }

            article.addClass('basic-article--linked');

            article.on('click', function (e) {
                window.location.href = link.attr('href');
            });
        });
    });
})(jQuery);
